import React, { memo } from 'react';

import { areEqualShallow } from 'Utils/equalityChecks';
import Clock from '../../../Assets/clock.svg';

// Custom css
import classes from './clock.module.css';

interface Props {
  className?: string;
  id?: string;
  onClick?: (e: any) => void;
  onKeyUp?: (e: any) => void;
}
const ClockSvg = ({ className = '', id, onClick, onKeyUp }: Props) => (
  <Clock id={id} className={`${classes.iconBase} ${className || ''}`} onClick={onClick} onKeyUp={onKeyUp} />
);

ClockSvg.defaultProps = {
  className: undefined,
  id: undefined,
  onClick: undefined,
  onKeyUp: undefined,
};

const ClockSvgMemo = memo(ClockSvg, areEqualShallow);

export { ClockSvgMemo as ClockSvg };
